<template>
    <contactinfo-tile @onsave="save" :editmodel="editmodel"
                      :parentmodel="origmodel" :componenterr="componenterr" :watchers="['email','confirmemail']"
                      :tileicon="'fas fa-envelope-open-text'" tile-header="Email" :tile-body="editmodel.email"
                      :savingdata="isSavingData" :openedit="openedit"
                       @isdirty="$emit('isdirty')" @isclean="$emit('isclean')" :contentblocks="contentblocks"
                       :isemail="true">
        <template v-slot:subicononclose>
            <label class="main ml-1 px-2 info-bg-color rounded"><i class="fas fa-check-circle mr-1 iconsmall"></i> Verified</label>
        </template>
        <template v-slot:subicononopen>
            <label v-if="editmodel.email" class="main ml-1 px-2 info-bg-color rounded h6 p-2"><i class="fas fa-check-circle mr-1 iconsmall"></i>Verified</label>
        </template>
        <template v-slot:component>
            <form class="w-100">
                <div class="row">
                    <div class="col-12">
                        <p class="warm">
                            {{ editmodel.email }}
                        </p>
                    </div>
                </div>

                <forminput :validationmsgs="contentblocks" :id="'email'" :validations="['email']" :label="origmodel.email" @onmodelchange="editmodel.email=arguments[0]" @onmodelerror="componenterr=true"
                           :maxlength="'90'" :placeholder="contentblocks.email" :editmodel="editmodel.email" :required="true" @onmodelvalid="componenterr=false" :parenterr="errorModel.email1" :cssclass="errorModel.email1 !=''?cssclass:''">
                </forminput>

                <forminput :validationmsgs="contentblocks" v-if="editmodel.email != parentmodel" :validations="['email']" :id="'confirmemail'" label="Confirm Email" @onmodelchange="editmodel.confirmemail=arguments[0]" @onmodelerror="componenterr=true"
                           :maxlength="'90'" :placeholder="contentblocks.email" :editmodel="editmodel.confirmemail" :required="true" @onmodelvalid="componenterr=false" :parenterr="errorModel.email2" :cssclass="errorModel.email2 !=''?cssclass:''">
                </forminput>
            </form>
        </template>
    </contactinfo-tile>
</template>
<script>
    import Vue from 'vue';
    import infotile from './tile.vue';
    import forminput from './forminput.vue';
    import { SettingsHttpSvc } from '@PortalHttpServices/portal.settings.httpservice';
    import { IsModelStateError } from '@SharedServices/validation.service';
    export default {
        name: 'address-info',
        props: {
            parentmodel: {},
            openwheninvalid: false,
            openedit: false,
            contentblocks: {}
        },
        components: {
            'contactinfo-tile': infotile,
            'forminput': forminput,
        },
        watch: {
            "editmodel.email": {
                handler(n, o) {
                    if(n !=o)this.validate();
                },
            },
            "editmodel.confirmemail": {
                handler(n, o) {
                    if (n != o)this.validate();
                },
            },
        },
        data: function () {
            return {
                errorModel: {
                    email1: "",
                    email2:""
                },
                origmodel: {},
                editmodel: {},
                componenterr: false,
                cssclass: "",
                isSavingData:false,
                response: {}
            }
        },
        created: function () {
            this.load();
        },
        methods: {
            save: function () {
                this.isSavingData = true;
                SettingsHttpSvc.ChangeEmail(this.editmodel.email, this.editmodel.confirmemail)
                    .done(response => {
                        this.$emit('onsave', this.editmodel.email, this.parentmodel);
                    }).fail((xhr, textStatus, obj) => {
                        if (IsModelStateError(xhr)) {
                            this.componenterr = true;
                            this.errorModel.email1 = xhr.responseJSON.email1[0];
                            this.cssclass = "is-invalid"
                        }
                    }).always(x => this.isSavingData = false);
            },
            validate() {
                this.cssclass = ""
                this.errorModel.email2 = "";
                this.errorModel.email1 = "";
                if ((this.editmodel.email != this.parentmodel || this.editmodel.confirmemail != "")
                    && this.editmodel.email != this.editmodel.confirmemail) {
                    this.componenterr = true;
                    if (this.editmodel.confirmemail) {
                        this.errorModel.email2 = this.contentblocks.emailMismatch;
                        this.cssclass = "is-invalid"
                    }
                }
            },
            load: async function () {
                this.response = await SettingsHttpSvc.ChangeEmailInitData();
                this.origmodel = {
                     email: this.response.userEmailAddress,
                     confirmemail :""
                 }
                this.editmodel = Vue.util.extend({}, this.origmodel);
                console.log(this.editmodel);
            }
        }

    }
</script>